
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-account/design-services",
      function () {
        return require("private-next-pages/my-account/design-services.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-account/design-services"])
      });
    }
  